import CustomFieldsManager from "../../../gd/manager/custom-fields-manager"
import FieldProto from "../../../fields3/proto/field-proto"

const debug = false
// const debug = "filterTasksCustomFields"

export function filterTasksCustomFields(customFields: FieldProto[], options?: {
    taskTypesIds?       : ID[]
    projectId?          : ID
    customFieldsIds?    : ID[]
}) {
    let customFieldsIds: ID[] | undefined
    // customFieldsIds may be passed as parameter
    if (options?.customFieldsIds) {
        customFieldsIds = options.customFieldsIds
    } else if (options?.projectId) {
        // or customFieldsIds ay be combined for passed taskTypesIds and/or projectId
        customFieldsIds = _.map(CustomFieldsManager.getProjectTaskListCustomFields(options?.taskTypesIds, options.projectId, [gd.const.customFields.scope.TASK]), cf=>cf.id)

        debug && console.log(debug, 'process', customFieldsIds, options.projectId)
    }

    // filter out all custom fields that do not belong passed task types or projectId
    return _.filter(customFields, (field:FieldProto)=>{
        return (!customFieldsIds || customFieldsIds.includes(field.fieldId)) && field.isColorCodingAvailable
    })
}